import { CircularProgress } from '@mui/material'

type Props = {
  color?: 'primary' | 'secondary' | 'inherit'
  className?: string
  size?: number | string
}

const Spinner = ({ color = 'primary', className, size }: Props) => (
  <CircularProgress color={color} className={className} size={size} />
)

export const SpinnerFullScreen = ({ color = 'primary', className, size = 60 }: Props) => (
  <div
    style={{
      display: 'flex',
      width: '100vw',
      height: '100vh',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
    <Spinner color={color} className={className} size={size} />
  </div>
)

export default Spinner
